export class MarketPlaceCategoryDto {
    uuid: string;
    sourceId: string;
    nameUk: string;
    nameRu: string;
    childrenCount: number;
    parentSourceId: string;

    constructor(
        uuid: string,
        source_id: string,
        name_uk: string,
        name_ru: string,
        children_count: number,
        parent_source_id: string
    ) {
        this.uuid = uuid;
        this.sourceId = source_id;
        this.nameUk = name_uk;
        this.nameRu = name_ru;
        this.childrenCount = children_count;
        this.parentSourceId = parent_source_id;
    }
}